
import { CssBaseline } from '@mui/material'
import withStyles from '@mui/styles/withStyles'
import React from 'react'
import QRCode from '../components/QRCode'

const styles = (theme) => ({

})

class PrintQRCode extends React.Component {
    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search)
        const print = urlParams.get('print')

        if (print == 'true') {
            window.print()
        }
    }

    render() {
        const urlParams = new URLSearchParams(window.location.search)

        return <>
            <CssBaseline />
            <QRCode title={urlParams.get('title')} value={urlParams.get('value')} />
        </>
    }
}

export default withStyles(styles, { withTheme: true })(PrintQRCode)
